<script>
import Layout from '@layouts/main.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'
import BaseConnections from '@components/_base-conections.vue'
import { replaceStore, replaceMutations } from '@state/helpers'

export default {
  page: {
    title: '02 00 Planning Overvie',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Overvie page.' },
    ],
  },
  components: {
    Layout,
    BaseVidPLayer,
    BaseConnections,
  },
  computed: {
    isPanelOpen() {
      return replaceStore.isNavOpen
    },
  },
  mounted() {
    replaceMutations.setIsNavOpen(true)
  },
  methods: {
    fadeStage() {
      this.$refs.fadeStage.classList.add('go')
    },
  },
}
</script>

<template>
  <Layout
    way-name="Choose Your Path"
    next-loc="Location B"
    next-title="EXPLORATION DRILLING"
    :hide-back="true"
    :hide-next="true"
  >
    <BaseVidPLayer
      ref="bgVideo"
      src="journey1-0.mp4"
      poster="journey1-0.png"
      next-path="01-A-exploration-planning"
      :pause="0.3"
    />
    <div ref="fadeStage" class="fadeStage">
      <BaseConnections d-val="M27,37, L66,23, L82,22.5, L61,82, Z" />
      <BaseHotspot :pos-x="25" :pos-y="32" pos-unit="%" :rot-x="57" />
      <BaseHotspot :pos-x="59" :pos-y="78" pos-unit="%" :rot-x="57" />
      <BaseHotspot :pos-x="63" :pos-y="18" pos-unit="%" :rot-x="57" />
      <BaseHotspot :pos-x="80" :pos-y="18" pos-unit="%" :rot-x="57" />
    </div>
  </Layout>
</template>

<style lang="scss">
.fadeStage {
  opacity: 1;
  transition: opacity 1s;

  &.go {
    opacity: 0;
  }
}
</style>
